import { createSelector } from '@reduxjs/toolkit';

export const selectSelectedOptionIndex = (state) => state.softwareProducts.selectedOptionIndex;
export const selectProduct = (state) => state.softwareProducts.product;
export const selectVariants = (state) => state.softwareProducts.variants;
export const selectOptionTypes = (state) => state.softwareProducts.option_types;
export const selectOptionValueGroups = (state) => state.softwareProducts.optionValueGroups;
export const selectSelectedVariant = (state) => state.softwareProducts.selectedVariant;
export const selectNumberOfUsers = (state) => state.softwareProducts.numberOfUsers;
export const selectAvailableNumberOfUsers = (state) => state.softwareProducts.availableNumberOfUsers;
export const selectAvailableLicenseSpans = (state) => state.softwareProducts.availableLicenseSpans;
export const selectLicenseSpan = (state) => state.softwareProducts.licenseSpan;
export const selectIsAddingToCart = (state) => state.softwareProducts.isAddingToCart;

export const selectDataForCart = createSelector(
  [
    selectProduct,
    selectVariants,
    selectSelectedVariant,
    selectNumberOfUsers,
    selectLicenseSpan,
    selectAvailableNumberOfUsers,
    selectAvailableLicenseSpans,
    selectIsAddingToCart,
    selectOptionValueGroups
  ],
  (
    product,
    variants,
    selectedVariant,
    numberOfUsers,
    licenseSpan,
    availableNumberOfUsers,
    availableLicenseSpans,
    isAddingToCart,
  ) => {
    const licenseType = selectedVariant?.option_values.find((optionValue) => optionValue.option_type_name === 'license-type')?.presentation;
    const activationMethod = selectedVariant?.option_values.find((optionValue) => optionValue.option_type_name === 'activation_method')?.presentation;

    const productName = product.name;
    const licenseSpanPresentation = availableLicenseSpans.find((span) => span.value === licenseSpan)?.text;

    const licenseTypeText = `${licenseType} ${activationMethod}`;
    return {
      product,
      productName,
      variants,
      selectedVariant,
      numberOfUsers,
      licenseSpan,
      licenseSpanPresentation,
      availableNumberOfUsers,
      availableLicenseSpans,
      licenseType,
      licenseTypeText,
      isAddingToCart,
    };
  },
);
